import { useState } from "react";
import { navItemShape } from "../PrimaryNav/primaryNavTypes.js";
import useClickAway from "../../../common/useClickAway.js";
import LinkDescriptionsMegaMenu from "./LinkDescriptionsMegaMenu.jsx";
import CallToActionMegaMenu from "./CallToActionMegaMenu.jsx";
import FeaturedContentMegaMenu from "./FeaturedContentMegaMenu.jsx";

import cx from "classnames";

const propTypes = {
  item: navItemShape.isRequired,
};

const MegaMenuDropdown = (props) => {
  const { item, ...otherProps } = props;

  const [isOpen, setOpen] = useState(false);

  const itemRef = useClickAway({ isOpen, setOpen });

  return (
    <li
      className={cx("mega-menu__item", {
        "mega-menu__item--open": isOpen,
      })}
      ref={itemRef}
      {...otherProps}
    >
      {item.children && (
        <button
          type="button"
          className={cx("primary-nav__accordion-trigger", {
            "primary-nav__accordion-trigger--open": item.children && isOpen,
          })}
          onClick={() => setOpen((open) => !open)}
        >
          {item.title}
        </button>
      )}
      {item.menuType === "Link Descriptions" && (
        <LinkDescriptionsMegaMenu
          item={item}
          className="link-descriptions__dropdown mega-menu__dropdown"
        />
      )}
      {item.menuType === "Call to Action" && (
        <CallToActionMegaMenu
          item={item}
          className="call-to-action__dropdown mega-menu__dropdown"
        />
      )}
      {item.menuType === "Featured Content" && (
        <FeaturedContentMegaMenu
          item={item}
          isMegaMenuOpen={isOpen}
          parentClasses="featured-content__dropdown mega-menu__dropdown"
        />
      )}
    </li>
  );
};

MegaMenuDropdown.propTypes = propTypes;
export default MegaMenuDropdown;
